/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { isRegisteredUserLoggedIn } from 'sarsaparilla/auth';
import type { AuthScreen } from '../../redux/authModal.slice';

export function isAuthScreen(screen: unknown): screen is AuthScreen {
    return (
        screen === 'login' ||
        screen === 'createAccount' ||
        screen === 'requestPasswordReset' ||
        screen === 'mfaCode'
    );
}

/**
 * Sanitize the redirect URL to prevent redirecting to a malicious site
 */
function sanitizeUrl(url?: string | null) {
    if (!url || typeof url !== 'string') {
        return null;
    }

    // If the URL points to a different domain, then we ignore for security
    if (
        url.includes('//') ||
        url.toLowerCase().includes('http') ||
        url.toLowerCase().includes('java') ||
        url.toLowerCase().includes('\\n') ||
        url.toLowerCase().includes('\\t')
    ) {
        return null;
    }

    return url;
}

export function maybePerformRedirect() {
    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams(currentUrl.search);
    const redirectParam = params.get('redirect');

    if (!redirectParam) {
        return;
    }

    const sanitizedUrl = sanitizeUrl(redirectParam);
    params.delete('redirect');

    // Reconstruct the current url without the redirect search param, but keep the rest
    const newCurrentURL = `${currentUrl.pathname}${params.size ? `?${params.toString()}` : ''}`;
    window.history.replaceState({}, '', newCurrentURL);

    if (sanitizedUrl && isRegisteredUserLoggedIn()) {
        window.location.pathname = sanitizedUrl;
    }
}
